import { HttpBaseApiWrapper } from 'service/HttpBaseApiWrapper'
import { URLPrefix } from 'service/url'

import { BookingRequestStateEnum, IBookingRequest } from './BookingRequestModel'
import { BookingRequestsListParams } from './BookingRequestsList/useBookingRequestsListCtx'

interface IBookingRequestsResponseJSON {
  requests: IBookingRequest[]
  total: number
}

interface BookingRequestServiceProps {
  http: HttpBaseApiWrapper
}

export class BookingRequestService {
  http: HttpBaseApiWrapper

  constructor(props: BookingRequestServiceProps) {
    this.http = props.http
  }

  getBookingRequests = (params: BookingRequestsListParams): Promise<IBookingRequestsResponseJSON> => {
    return this.http.get<IBookingRequestsResponseJSON>('/bookingRequests', {
      params,
      urlPrefix: URLPrefix.Root,
    })
  }

  getBookingRequest = (requestId: string): Promise<IBookingRequest> => {
    return this.http.get<IBookingRequest>(`/bookingRequests/${requestId}`, {
      urlPrefix: URLPrefix.Root,
    })
  }

  approveBookingRequest = (requestId: string, reason?: string) => {
    return this.http.put<{ shipmentId: string }>(
      `/bookingRequests/${requestId}/review`,
      {
        state: BookingRequestStateEnum.APPROVED,
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        ...(reason.length > 0 ? { reason } : {}),
      },
      {
        urlPrefix: URLPrefix.Root,
      }
    )
  }

  rejectBookingRequest = (requestId: string, reason?: string) => {
    return this.http.put(
      `/bookingRequests/${requestId}/review`,
      {
        state: BookingRequestStateEnum.REJECTED,
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        ...(reason.length > 0 ? { reason } : {}),
      },
      {
        urlPrefix: URLPrefix.Root,
      }
    )
  }
}
